import apiFetcher, { apiFetcherArgs } from '@/api/apiFetcher';
import { useNetwork } from '@/hooks';
import useSWR from 'swr';

export default function useApi<T>(
  args: apiFetcherArgs
): [T | undefined, Error | undefined] {
  const network = useNetwork();
  const requestArgs = network
    ? {
        ...args,
        queryParams: { ...args.queryParams, network }
      }
    : args;

  const { data, error } = useSWR<T, Error, apiFetcherArgs>(
    requestArgs,
    apiFetcher
  );

  return [data, error];
}
